module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [(_vm.footer1 && _vm.footer2) ? _c('div', {
    staticClass: "container",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-offset": "-100"
    }
  }, [_c('div', {
    staticClass: "columns content is-centered is-gapless is-multiline",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('p', {
    staticClass: "column is-8 has-text-left is-hidden-mobile",
    staticStyle: {
      "color": "white"
    }
  }, [(_vm.footer1) ? _c('markdown', {
    attrs: {
      "source": _vm.footer1
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "column is-4 has-text-right is-hidden-mobile",
    staticStyle: {
      "color": "white"
    }
  }, [(_vm.footer2) ? _c('markdown', {
    attrs: {
      "source": _vm.footer2
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "column is-12 has-text-centered is-hidden-tablet",
    staticStyle: {
      "color": "white"
    }
  }, [(_vm.footer2) ? _c('markdown', {
    attrs: {
      "source": _vm.footer2
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "column is-12 has-text-centered is-hidden-tablet",
    staticStyle: {
      "color": "white",
      "margin-top": "20px"
    }
  }, [(_vm.footer1) ? _c('markdown', {
    attrs: {
      "source": _vm.footer1
    }
  }) : _vm._e()], 1)])]) : _c('div', {
    staticStyle: {
      "height": "80px"
    }
  }, [_vm._v("\n     \n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d05ec05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 978
// module chunks = 1